import { createStore, combineReducers, applyMiddleware, Middleware, compose } from 'redux'
import thunk from 'redux-thunk'

import { AuthReducer as auth } from './auth'
import { InfoReducer as info } from './info'
import { ConstReducer as constants } from './constants'
import { ModalReducer as modals } from './modals'
import { GreetReducer as greetings } from './greetings'
import { PropsReducer as props } from './props'

const composeEnhancers = (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const loggerMiddleware: Middleware = (api) => (next) => (action) => {
  // console.log('Middleware', store.getState())
  return next(action)
}

const reducers = combineReducers({
  constants,
  modals,
  greetings,
  auth,
  info,
  props,
})

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk, loggerMiddleware)))

export type RootState = ReturnType<typeof reducers>
export type AppDispatch = typeof store.dispatch
export default store
